import { FC, useEffect } from "react";
import { FieldFormV2, FieldV2, LoadingV2 } from "@ucl/library";
import { FIELD_KEYS } from "@/constants";
import "./FinancialApplicationDocumentsForm.scss";
import { FinancialApplication } from "@/types/FinancialApplication";
import { useFinancialApplicationForm } from "@/hooks/useFinancialApplicationForm";
import {
  useFinancialApplicationFormSectionValidation,
  FinancialApplicationFormValidationDisplayBehavior,
} from "@/hooks/useFinancialApplicationFormSectionValidation";
import { FinancialApplicationSection } from "@/types/enums";
import { useFinancialApplicationCoreData } from "@/hooks/useFinancialApplicationCoreData";

export interface FinancialApplicationDocumentsFormProps {
  financialApplicationId: string;
  autoValidationBehavior?: FinancialApplicationFormValidationDisplayBehavior;
  availableFields?: string[];
  showHeader?: boolean;
}

export const FinancialApplicationDocumentsForm: FC<FinancialApplicationDocumentsFormProps> = (
  props
) => {
  const {
    formValue,
    setFormValue,
    saveFinancialApplicationDocuments,
    schemaFactory,
    formBuilder,
    fieldFormModule,
  } = useFinancialApplicationForm(props.financialApplicationId);

  const { coreData, refreshCoreData } = useFinancialApplicationCoreData(
    props.financialApplicationId
  );

  useEffect(() => {
    refreshCoreData();
  }, []);

  const { validationErrors } = useFinancialApplicationFormSectionValidation(
    props.financialApplicationId,
    FinancialApplicationSection.FinancialApplicationDocuments,
    props.autoValidationBehavior
  );

  if (!schemaFactory || !formBuilder || !formValue) {
    return (
      <section className="financial-application-documents-form">
        <LoadingV2 />
      </section>
    );
  }

  return (
    <div className="financial-application-documents-form">
      <FieldFormV2<FinancialApplication>
        ref={fieldFormModule}
        value={formValue}
        fieldSchemaFormBuilder={formBuilder}
        onFormSubmit={async (value) => {
          await saveFinancialApplicationDocuments(value);
        }}
        onFieldChanged={(newValue, newFieldValue) => {
          setFormValue(newValue, newFieldValue, true);
        }}
        errors={validationErrors}
        availableFields={props.availableFields}
      >
        <FieldV2
          fieldProps={FIELD_KEYS.FINANCIAL_APPLICATION.FINANCIAL_APPLICATION_DOCUMENTS}
          complexFieldValue={{
            financialApplicationId: props.financialApplicationId,
            showHeader: props.showHeader,
            applicationDetails: coreData?.applicationDetails,
          }}
        />
      </FieldFormV2>
    </div>
  );
};
